// extracted by mini-css-extract-plugin
module.exports = {"container":"dmca_container__nToWH"};